// extracted by mini-css-extract-plugin
export default {"card":"BarChart_card__+UwDN","cardTopic":"BarChart_cardTopic__XUnZi","title":"BarChart_title__l2GgK","barChart":"BarChart_barChart__wwnXh"};